<template>
    <div class="index">
        <div class="title">欢迎访问…</div>
        <div class="name">{{ useName }}</div>
    </div>
</template>

<script>
import { store } from '../../store';

export default {
    data() {
        return {
            useName:store.state.userInfo.name
        }
    },
    methods: {

    }
}
</script>
<style scoped>
.title{
    display: flex;
    color: #07026c;
    font-size: 108px;
    font-weight: bold;
    font-family: 'SimSun', '宋体', serif;
    padding-top: 26vh;
    padding-left: 10vw;
}

.name{
    display: flex;
    color: #07026c;
    font-size: 60px;
    font-weight: bold;
    font-family: 'SimSun', '宋体', serif;
    padding-top: 30px;
    padding-left: 10vw;
}

.index{
    /* display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center; */
    height: calc(100vh - 80px);
    margin: -20px;
    /* background-image: url('https://oss.jlszhgh.com/employment/images/pc-bj.jpg');
    background-repeat: no-repeat;
    background-position: center; */

    background: url('https://oss.jlszhgh.com/employment/images/pc-bj.jpg') no-repeat center center fixed;
        background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/Index.vue